module.exports = __webpack_public_path__ + "static/media/26_Aug_2022_ET_Leadership_ecellence_Awards.10b5ac53.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/26_Aug_2022_ET_Leadership_ecellence_Awards.webp
// module id = 302
// module chunks = 0